import { Col, Container, Jumbotron, Row } from "react-bootstrap";

export default function NoDataToShow({text}){
    return (
        <Container fluid>
            <Row className="p-5">
                <Col>
                    <Jumbotron className="w-100">
                        <p className="d-bock text-center">{text}</p>
                    </Jumbotron>
                </Col>
            </Row>
        </Container>
    )
}